export class ClientConfigImages {
  loginPageBackground: string | null = null;
  logo: string | null = null;
  logo_fr_CA: string | null = null;
  logoMiddle: string | null = null;
  logoRight: string | null = null;
  navbarLogo: string | null = null;
  navbarLogo_fr_CA: string | null = null;
  homePageLinks: string | null = null;
}
